import { Box, Typography } from "@mui/material";
import { BORDER, TEXT, TEXT_SOFT } from "../constants";

const TONE = {
  positive: { bg: "#ecfdf5", border: "#a7f3d0", title: "#047857" },
  warning: { bg: "#fffbeb", border: "#fde68a", title: "#b45309" },
  danger: { bg: "#fef2f2", border: "#fecaca", title: "#b91c1c" },
  neutral: { bg: "#f8fafc", border: BORDER, title: TEXT },
};

export default function InsightsRow({ highlights = [] }) {
  if (!highlights.length) return null;

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)", xl: "repeat(5, 1fr)" },
        gap: 1.5,
      }}
    >
      {highlights.map((item, i) => {
        const tone = TONE[item.tone] || TONE.neutral;
        return (
          <Box
            key={`${item.title}-${i}`}
            sx={{
              p: 2,
              borderRadius: "12px",
              bgcolor: tone.bg,
              border: `1px solid ${tone.border}`,
              minWidth: 0,
            }}
          >
            <Typography sx={{ fontWeight: 700, color: tone.title, fontSize: 13, lineHeight: 1.35 }}>
              {item.title}
            </Typography>
            <Typography sx={{ color: TEXT_SOFT, fontSize: 12, mt: 0.6, lineHeight: 1.4 }}>
              {item.detail}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}
